import React from "react";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

const BaseHeader = styled.span.attrs(({ lineHeight, color, marginsmall, margin, size, theme }) => ({
	fontSize: size ? size : "",
	color: color ? color : theme.colors.black,
	marginSmall: marginsmall ? marginsmall : margin ? margin : 0,
	margin: margin ? margin : 0,
	lineHeight: lineHeight ? lineHeight : "",
}))`
	font-size: ${({ fontSize }) => (fontSize ? fontSize : "")};
	font-family: ${({ font, theme }) => (font ? font : theme.font)};
	color: ${({ color }) => color};
	font-weight: bold;
	line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : "")};
	margin: ${({ marginSmall }) => marginSmall};
	${media.greaterThan(breakpoints.ipad)`
    	margin: ${({ margin }) => margin};

  	`}
`;

export const H1 = styled(BaseHeader).attrs(({ lineHeight }) => ({
	as: "h1",
}))`
	font-size: 28px;
	line-height: 38px;

	${media.greaterThan(breakpoints.ipad)`
		font-size: 36px;
		line-height: 54px;
  	`};
`;
export const Line = styled.span`
	background-color: ${({ theme }) => theme.colors.bg2};
	width: 100%;
	height: 2px;
`;
const HeadingWrapper = styled.div`
	display: ${({ display }) => display};
	flex-direction: column;
	margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : "20px")};
	h1 {
		margin-bottom: 16px;
	}
`;
export const PageHeader = ({ Heading, ...rest }) => {
	return (
		<HeadingWrapper {...rest}>
			<H1>{Heading}</H1>
			<Line />
		</HeadingWrapper>
	);
};

export const H2 = styled(BaseHeader).attrs({
	as: "h2",
})`
	font-size: 24px;
	line-height: 30px;

	${media.greaterThan(breakpoints.ipad)`
		font-size: 32px;
		line-height: 38px;
	`}
`;

export const H3 = styled(BaseHeader).attrs({
	as: "h3",
})`
	font-size: 20px;
	line-height: 26px;

	${media.greaterThan(breakpoints.ipad)`
		font-size: 24px;
		line-height: 30px;
	`}
`;

export const H4 = styled(BaseHeader).attrs({
	as: "h4",
})`
	font-size: 18px;
	line-height: 24px;

	${media.greaterThan(breakpoints.ipad)`
		font-size: 20px;
		line-height: 24px;
  	`}
`;
